module.exports = __webpack_public_path__ + "img/成本极省ico.6e060b5d.png";